<template>

   
 <v-card  dense>
     <v-toolbar dense color='primary' dark>
       Create Company
       <v-spacer />

       <v-btn icon
        ><v-icon @click="$emit('closeDialog',true)" medium>fas fa-times-circle</v-icon></v-btn
      >
      </v-toolbar>

      <v-container fluid  >
  <v-form v-model="valid">

     <v-layout>
        <v-flex xs2>
          <span>
            <ImageCard
              :documentId="company.logo_profile_id"
              :keyId="company.id"
              height="48px"
              size="large"
              width="48px"
              v-on:imageChanged="updateLogo"
            />
          </span>
        </v-flex>
       <v-flex xs3 sm2>
      <v-text-field
        class="style-input mr-2 sm3"
        label="Code"
        v-validate="'required'"
        data-vv-name="company_code"
        type="text"
        :error-messages="errors.collect('company_code')"
        v-model="company.company_code"
        required
      />
      </v-flex>
      <v-flex xs3 sm8>
    
      <v-text-field
        class="style-input mr-2"
        label="Name"
        v-validate="'required'"
        data-vv-name="name"
        type="text"
        :error-messages="errors.collect('name')"
        v-model="company.name"
        required
      />
      </v-flex>
      </v-layout>
      <v-layout>
        <v-flex sm4>
      <v-text-field
        class="style-input mr-2"
        label="First line of Address"
        v-validate="'required'"
        data-vv-name="address1"
        type="text"
        :error-messages="errors.collect('address1')"
        v-model="company.address1"
      />      
      </v-flex>
      <v-flex sm4>
      <v-text-field
        class="style-input mr-2"
        label="Second line of Address"
        v-validate="'required'"
        data-vv-name="address2"
        type="text"
        :error-messages="errors.collect('address2')"
        v-model="company.address2"
      />
      </v-flex>
      <v-flex sm4>
      <v-text-field
        class="style-input mr-2"
        label="City"
        v-validate="'required'"
        data-vv-name="city"
        type="text"
        :error-messages="errors.collect('city')"
        v-model="company.city"
      />
      </v-flex>
      </v-layout>
      <v-layout>
      <v-flex sm4>
        <v-select
          class="style-input mr-2"
          label="Country"
          v-validate="'required'"
          data-vv-name="country_id"
          item-text="name"
          item-value="id"
       
          :error-messages="errors.collect('country_id')"
          v-model="company.country_id"
          :items="countries"
        ></v-select>
      </v-flex>
      <v-flex sm5>
        <v-select
          class="style-input mr-2"
          label="State"
          v-validate="'required'"
          data-vv-name="state_id"
          item-text="name"
          item-value="id"
          :error-messages="errors.collect('state_id')"
          v-model="company.state_id"
          :items="states"
        ></v-select>
      </v-flex>
      <v-flex sm3>
      <v-text-field
        class="style-input mr-2"
        label="zip"
        v-validate="'required'"
        data-vv-name="zip"
        type="text"
        :error-messages="errors.collect('zip')"
        v-model="company.zip"
      />
      </v-flex>
      </v-layout>
      <v-layout>
      <v-flex sm3>
       <v-select
          class="style-input mr-2"
          label="Auth Type"
          v-validate="'required'"
          data-vv-name="auth_type"
          item-text="name"
          item-value="id"
       
          :error-messages="errors.collect('auth_type')"
          v-model="company.auth_type"
          :items="authTypes"
        ></v-select>
      
      </v-flex>
      
      <v-flex sm3>

        <v-text-field
        label="Database  String"
        v-model="company.db_connection_string"
        />

      </v-flex>
      <v-flex sm3>

        <v-text-field
        label="Image Path"
        v-model="company.image_path"
        />

      </v-flex>
      
      </v-layout>
      <v-layout>
      <v-flex sm12>
      <v-textarea
          label="Description"
          value=""
          hint="Description"
           v-model="company.description"
        ></v-textarea> 
      </v-flex>
      </v-layout>        
        <v-layout class="justify-center">
    <div class="form-btn2">
      <v-btn  @click="submit" small color="primary">Save</v-btn>
      <v-btn  @click="clear" small color="primary">Clear</v-btn>
    </div>
    </v-layout>

  </v-form>
         </v-container>
  </v-card>
 
</template>
<style>
</style>
<script>
//import UserModel from '../../api/service/UserService.js';

import CompanyModel from '@/api/service/CompanyService';
import ImageCard from "@/components/ImageCard.vue";
export default {
  components:{
    ImageCard
  },
  $_veeValidate: {
    validator: 'new'
  },  
  data: () => ({
    saveCard: true,
    valid: true,
    countries:[
      {"id":"US",name:"US"}
    ],
    states:[
      {"id":3953,name:"New Jersey"}
    ],
    active:[
      {"id":0,name:"Active"},
      {"id":1,"name":"Inactive"}
    ],
    authTypes: [
        {"id":"TB","name":"Tibura"},
        {"id":"LD","name":"Ldap"},
        {"id":"GO","name":"Gmail"},
        {"id":"36","name":"Office 365"}
    ],
    company: {
      
    }

  }),
  created: function() {
    },
    mounted: function(){
    },
  methods: {
    async updateLogo($image) {
      this.company.logo_profile_id= $image.id
      await CompanyModel.update({"id":this.company.id,logo_profile_id:$image.id})
    },
    setcompanies($company){
            this.company = $company[0];
            console.log(this.company)
        },

    validate() {
      this.valid=true;
    },
    submit () {
      this.$validator.validateAll();
      this.validate();
      console.log(this.valid)
      if (this.valid) {      
      var navigate = this.$router;
      var stores = this.$store;
     // console.log(localStorage)  
     this.company.active=1
      CompanyModel.create(this.company)
        .then(response => {
            navigate.replace('/companies')
            
        }).catch(error => {
            console.log(error);
            console.log('I am getting error')
            //alert(error);
        }); 
      }
      },
    clear () {
      this.form = {};
      this.$validator.reset();
    },
    validatePortal() {
      CompanyModel.validate(this.company)
    }
  }
};
</script>

<style  scoped>
  .style-input {
    padding:0px;
    margin:0px;
    width:100%;
  }
  .style-input1 {
    background-color:yellow;
  }
</style>
